module.exports = __webpack_public_path__ + "static/media/soviet_engineer_120.5e000751.png";